import { Zap } from "lucide-react";

export const EmailFlash = ({ text = "Sends an automatic email to the client" }) => (
  <span data-testid="email-flash-warning" className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest text-[#B45309]">
    <Zap size={11} className="fill-[#F59E0B] text-[#B45309] shrink-0" /> {text}
  </span>
);
